/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Users_Help_Maintenance_ExceptionInputs */



/**
* | output |
* | --- |
* | "(except Maintenance, air quality and presence data)" |
*
* @param {Users_Help_Maintenance_ExceptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const users_help_maintenance_exception = /** @type {((inputs?: Users_Help_Maintenance_ExceptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Users_Help_Maintenance_ExceptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("(except Maintenance, air quality and presence data)")
	return /** @type {LocalizedString} */ ("(sauf Maintenance, les données de qualité de l'air et de présence)")
});